import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { ReactComponent as DownloadIcon } from '../../assets/icons/download-icon.svg'
import { MAXIMUM_ANSWER_SESSIONS_FOR_EXPORT } from '../../utils/constants'
import { getAnswerSessions, getBenchmarks } from './apiCallsForDataExport'
import { createXLFile } from './createXLFile'
import styles from './ExportData.module.scss'

/**
 * renders the 'export data' page which allows admins to export
 * all answer-sessions and/or all current benchmarks
 */
const ExportData = () => {
  const jt = useSelector(state => state.jsonText.jsonText)
  const user = useSelector(state => state.user.user)
  const location = useLocation()
  const navigate = useNavigate()

  // Check user is an admin. If not, go back to previous page or home.
  useEffect(() => {
    if (!user?.admin) handleUnauthorized()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, navigate, location])

  const handleUnauthorized = () => {
    toast.error('Access denied. Admins only.')
    // Go back if possible, otherwise to home
    if (location.key !== 'default') {
      navigate(-1)
    } else {
      navigate('/')
    }
  }

  const handleAnswerDownload = async () => {
    const { sessions, status } = await getAnswerSessions()
    if (status === 403) {
      handleUnauthorized()
      return
    }
    const message = sessions.length >= MAXIMUM_ANSWER_SESSIONS_FOR_EXPORT ?
      `${jt.block?.exportLimitReached || `The maximum number of Answer Sessions for Export has been reached`}: ${MAXIMUM_ANSWER_SESSIONS_FOR_EXPORT} !`
      : `${jt.block?.numberOfAnswerSessionsExported || `Number of Answer Sessions successfully found and exported`}: ${sessions.length}.`
    toast.success(message, { autoClose: 8000 })
    // console.log('handleAnswerDownload() sessions:', sessions)
    createXLFile(sessions, 'answer-sessions')
  }

  const handleBenchmarkDownload = async () => {
    const { benchmarks, status } = await getBenchmarks()
    if (status === 403) {
      handleUnauthorized()
      return
    }
    const message = `${jt.block?.numberOfBenchmnarksExported || `Number of benchmark items successfully found and exported`}: ${benchmarks.length}.`
    toast.success(message, { autoClose: 8000 })
    // console.log('handleBenchmarkDownload() benchmarks:', benchmarks)
    createXLFile(benchmarks, 'benchmarks')
  }

  return (
    <div>
      <div className={styles.pictureBackground}>
        <h1>{jt.label?.exportData || 'Export Data'}</h1>
        <p>
          {jt.block?.exportData ||
            'Here, as a Database Administrator, you can export and download the data in an Excel file format.\n' +
            'You can either export all the raw data of the questionnaire answers, or ' +
            'you can export last night\'s update of the Benchmark for all modules and categories.'}
        </p>
        <button className={styles.mainBtn} onClick={handleAnswerDownload}>
          <DownloadIcon className={styles.downloadIcon} alt='download icon' />
          {jt.label?.downloadAnswerSessions || 'Download Answer Sessions'}
        </button>
        <button className={styles.mainBtn} onClick={handleBenchmarkDownload}>
          <DownloadIcon className={styles.downloadIcon} alt='download icon' />
          {jt.label?.downloadCurrentBenchmark || 'Download Current Benchmark'}
        </button>
      </div>
    </div>
  )
}
export default ExportData
